module.exports = {"DateField::dateformat":"gg.mm.aaaa","DuplicateStep1::agbs":"CGC","phone_number_placeholder":"+41 79 111 11 11","SaleCreatePanel::agbs":"CGC","SaleCreatePanel::image":"Foto del titolo della proprietà","SaleCreatePanel::number":"Numero della proprietà","Search::agbs":"CGC","Search::i_agree_to_the_link":"Accetto le {agbs}","Search::i_agree_with_terms_and_conditions":"Accetto le CGC"}


//////////////////
// WEBPACK FOOTER
// ./src/app/locales/it-CH.json
// module id = 2280
// module chunks = 260